import { Directive, ElementRef, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[TrimText]'
})
export class TrimTextDirective {

  constructor(private readonly el:ElementRef,@Self() private readonly ngControl: NgControl) { }

  @HostListener("blur") onBlur() {
   const control = this.ngControl.control;
    if (control && typeof control.value === 'string') {
      // Trim the value and update the form control
      control.setValue(control.value.trim());
    }
  }  

}
